import MuiPopper from '@mui/material/Popper';
import { useClickAway } from '@/hooks/useClickAway';
import { forwardRef, RefObject, useRef } from 'react';

const Popper = forwardRef<
  HTMLDivElement,
  {
    className?: string;
    open: boolean;
    anchorEl: HTMLElement | null;
    children?: React.ReactNode;
    placement?: 'bottom-start' | 'bottom-end';
    offsetY?: number;
    onClose: () => void;
    onClick?: (e: React.MouseEvent) => void;
    'aria-label': string;
  }
>(
  (
    {
      className,
      open,
      anchorEl,
      children,
      placement = 'bottom-start',
      offsetY = 0,
      onClose,
      onClick,
      'aria-label': ariaLabel,
    },
    forwardedRef,
  ) => {
    const rootRef = useRef<HTMLDivElement>(null);
    const effectiveRef = forwardedRef || rootRef;

    useClickAway(effectiveRef as RefObject<HTMLElement>, (e) => {
      if (
        anchorEl &&
        e.target &&
        !anchorEl.contains(e.target as Node)
      ) {
        onClose?.();
      }
    });

    return (
      <MuiPopper
        open={open}
        anchorEl={anchorEl}
        ref={effectiveRef}
        placement={placement}
        className={className}
        onClick={(e) => onClick?.(e)}
        sx={[
          (theme) => ({
            zIndex: theme.zIndex.modal + 1,
          }),
        ]}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, offsetY] },
          },
        ]}
        role="tooltip"
        aria-label={ariaLabel}
      >
        {children}
      </MuiPopper>
    );
  },
);

Popper.displayName = 'Popper';

export default Popper;
